exports.cs = {
  EXT_UPDATES: {
    FROM: 'Od',
    TO: 'do',
    SHOW_MORE: 'Zobrazit další'
  }
}
